// Concordancia de número para los contadores de cabecera («1 venta» / «3 ventas»). Función pura —
// shared/lib (§6.2 de la arquitectura). Existe aquí porque cada dominio se había armado la suya.
export function plural(count: number, singular: string, pluralForm: string): string {
    return `${String(count)} ${count === 1 ? singular : pluralForm}`;
}
